import React, { memo } from "react";

export const GalleryImage = memo(({ title, largeImage, smallImage }) => {
    return (
        <div className="gallery-item">
            <div className="hover-bg">
                <a
                    href={largeImage}
                    title={title}
                    data-lightbox-gallery="gallery1"
                    aria-label={`View larger image of ${title}`}
                >
                    <div className="hover-text">
                        <h4>{title}</h4>
                    </div>
                    <img
                        src={smallImage}
                        className="img-responsive"
                        alt={title}
                        loading="lazy"
                    />
                </a>
            </div>
        </div>
    );
});

GalleryImage.displayName = 'GalleryImage';